import { createSlice } from "@reduxjs/toolkit";
import { customerContactApi } from "../../../Service/customerContact";
import { customerMedicalApi } from "../../../Service/customerMedical";
import { api } from "../../../Service/customers";
import { GetCustomerContact, GetCustomerDetail, GetcustomerLogs } from "../../async-actions/digitalmarketing/customer";
import { CustomerLog, CustomerLogApi } from "../../../Service/CustomerLogs";
import { CustomerAppointmentApi } from "../../../Service/CustomerAppointment";
import { CustomerJourneyApi } from "../../../Service/CustomerJourney";
import { CustomerReminderApi } from "../../../Service/CustomerReminder";
import { BranchesApi } from "../../../Service/branches";
// import branchList from "./branchList";

// const initialState = {
//     customerLogs: [],
//     customerMedical: {
//         id: null,
//         customerId: null,
//         ivf: 0,
//         ivfYear: null,
//         ivfMonth: null,
//         iui: 0,
//         iuiYear: null,
//         iuiMonth: null,
//         icsi: 0,
//         icsiYear: null,
//         icsiMonth: null,
//         miscarriages: 0,
//         miscarriagesYear: null,
//         miscarriagesMonth: null,
//         children: 0,
//         childrenONE: null,
//         childrenTWO: null,
//         childrenTHREE: null,
//         lmp: "",
//         healthIssues: "",
//         spouseHealthIssues: "",
//         occupation: "",
//         spouseOccupation: "",
//         areaOfInterest: "",
//         status: null
//     },
//     customerContact: {
//         id: 0,
//         customerId: "",
//         phone1: "",
//         phone2: "",
//         email1: "",
//         email2: "",
//         city: "",
//         area: "",
//         status: ""
//     },
//     customerDetail: {
//         id: null,
//         customerName: "",
//         age: 0,
//         sex: "",
//         spouseName: "",
//         spouseAge: 0,
//         spouseSex: "",
//         yearsMarried: "",
//         source: "",
//         status: false,
//         customerStatus: "",
//         serviceChoosen: ""
//     },
//     customerAppointment: {
//         id: null,
//         customerId: null,
//         appointmentDate: null,
//         appointmentTime: null,
//     },
//     customerJourney: [],
//     customerReminder: {
//         id: null,
//         customerId: null,
//         userId: null,
//         reminderTo: "",
//         reminderFor: "",
//         reminderOnce: "",
//         mediums: "",
//         status: "",
//         comments: ""
//     }
// };

const initialState = {
    branchDetails: {
        'id': 0,
        "branchName": "",
        "isMainBranch": 0,
        "address": "",
        "city": "",
        "state": "",
        "country": "",
        "pincode": "",
        "emailId": "",
        "mobileNo": "",
        "activeStatus": 0
    },
}

const customerSlice = createSlice({
    name: "branches",
    initialState,
    reducers: {
        resetReducer: () => initialState
    },
    // extraReducers: (builder) => {
    //     builder.addMatcher(BranchesApi.endpoints.getBranch.matchFulfilled, (state, action) => {
    //         let value = { branchList: action.payload['data'] }
    //         state = { ...state, ...value }
    //         console.log('state', state);
    //         return state
    //     })
    //     builder.addMatcher(BranchesApi.endpoints.addBranch.matchFulfilled, (state, action) => {
    //         console.log('action', action)
    //         state.branchDetails = { ...state.branchDetails, ...action.payload }
    //         console.log('state', state);
    //         return state
    //     })
    //     builder.addMatcher(BranchesApi.endpoints.getBranchById.matchFulfilled, (state, action) => {
    //         state.branchDetails = { ...state.branchDetails, ...action.payload }
    //         return state
    //     })
    //     builder.addMatcher(BranchesApi.endpoints.updateBranch.matchFulfilled, (state, action) => {
    //         console.log('updatin', action, state)
    //         return state
    //     })
    //     builder.addMatcher(BranchesApi.endpoints.deleteBranch.matchFulfilled, (state, action) => {
    //         console.log(action)
    //         // let value = { branchList: action.payload['data'] }
    //         // state = { ...state, ...value }
    //         // console.log('state', state);
    //         return state
    //     })
    
});
export default customerSlice.reducer;

export const {  resetReducer } = customerSlice.actions

